var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-center uppercase items-center w-full text-secondary text-xl poppins-bold"},[_c('div',{staticClass:"loader"}),(_vm.showText)?_c('div',{staticClass:"mt-2"},[_vm._v("Loading"+_vm._s(_vm.dots))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }